// AGC: Battle Mode Selection Modal for Tour (v6.9.0)
// AGC: Asks player if they want to play real PvE or simulation

import React from 'react'
import { Gamepad2, Play } from 'lucide-react'

// AGC: Click sound effect
const playClickSound = () => {
  try {
    const audio = new Audio('/sounds/click.mp3')
    audio.volume = 0.5 // AGC: Set volume to 50%
    audio.play().catch((error) => {
      // AGC: Silently fail if audio can't play (user interaction required, etc.)
      console.debug('AGC: Could not play click sound:', error)
    })
  } catch (error) {
    // AGC: Silently fail if audio creation fails
    console.debug('AGC: Could not create audio for click sound:', error)
  }
}

interface BattleModeSelectionModalProps {
  isOpen: boolean
  onSelectPvE: () => void
  onSelectSimulation: () => void
}

export const BattleModeSelectionModal: React.FC<BattleModeSelectionModalProps> = ({
  isOpen,
  onSelectPvE,
  onSelectSimulation,
}) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[10001] flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm">
      <div className="relative w-full max-w-md bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 border-2 border-cyan-500/40 rounded-2xl shadow-2xl p-6 space-y-6 animate-in fade-in zoom-in duration-300">
        {/* AGC: Header */}
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-cyan-500 to-purple-600 mb-4">
            <Gamepad2 className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Choose Your Battle Mode</h2>
          <p className="text-slate-300 text-sm">How would you like to play?</p>
        </div>

        {/* AGC: Mode Selection Buttons */}
        <div className="space-y-3">
          <button
            onClick={() => {
              playClickSound()
              onSelectPvE()
            }}
            className="w-full bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-500 hover:to-emerald-500 text-white font-bold py-4 px-6 rounded-xl transition-all shadow-lg shadow-green-500/30 hover:shadow-green-500/50 flex items-center justify-center gap-2"
          >
            <Play className="w-5 h-5" />
            <span>PLAY PvE</span>
          </button>

          <button
            data-tour="play-simulation-button"
            onClick={() => {
              playClickSound()
              onSelectSimulation()
            }}
            className="w-full bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-500 hover:to-cyan-500 text-white font-bold py-4 px-6 rounded-xl transition-all shadow-lg shadow-blue-500/30 hover:shadow-blue-500/50 flex items-center justify-center gap-2"
          >
            <Gamepad2 className="w-5 h-5" />
            <span>Play Simulation</span>
          </button>
        </div>

        {/* AGC: Info Text */}
        <div className="text-center text-xs text-slate-400 space-y-1">
          <p><strong className="text-green-400">PLAY PvE:</strong> Real on-chain battle with transactions</p>
          <p><strong className="text-blue-400">Play Simulation:</strong> Practice battle without wallet</p>
        </div>
      </div>
    </div>
  )
}

